<template>
  <integratedAccountManager></integratedAccountManager>
</template>

<script>
import integratedAccountManager from '../../comComponent/integratedAccountManager'
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  components: {
    integratedAccountManager
  },
  methods: {

  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/accountManager/integratedAccount.vue